import { Stack, Typography, Box, Chip } from '@mui/material';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { Field } from 'types/api/Tenant/AROKMS/DisplayTableTypes';
import eventEmitter, { EVENT_EMITTER_KEYS } from 'utils/EventEmitter';

interface DataInputFileUploadProps {
  name: string;
  onChange: (fileUrl: string) => void;
  fileUrl: string;
  label: string;
  required?: boolean;
  isEdit?: boolean;
  field: Field;
}

const INPUT_EDIT_MESSAGE = "Once you've submitted, this field can no longer be changed";

export function DataInputFileUpload(props: DataInputFileUploadProps) {
  const { fileUrl, required, isEdit, field } = props;

  const handleOnShowModalAttachment = () => {
    eventEmitter.emit(EVENT_EMITTER_KEYS.TIRGGER_SHOW_MODAL_ATTACHMENT_INSERT, {
      visible: true,
      url: Boolean(fileUrl) ? fileUrl : undefined,
      fieldName: field.name,
      fieldLabel: field.label,
    });
  };

  const totalAttachment = fileUrl ? fileUrl.split(',').filter(Boolean).length : 0;
  const hasAttachments = totalAttachment > 0;

  return (
    <Stack direction='column' marginTop={2.5} mb={2}>
      <Typography variant='input-label' fontWeight={700}>
        {field.label}
        {required && !field.disabled && <span style={{ color: 'red', marginLeft: 2 }}>*</span>}
      </Typography>
      {field.columnEditable === false && !isEdit && !field.disabled && (
        <Typography variant='input-label-gray' fontSize={12} mb={3}>
          {INPUT_EDIT_MESSAGE}
        </Typography>
      )}

      <Box
        onClick={handleOnShowModalAttachment}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 2,
          py: 1.5,
          mt: 0.5,
          borderRadius: 2,
          border: hasAttachments ? '1px solid #3B479730' : '2px dashed #D0D5DD',
          bgcolor: hasAttachments ? '#F5F6FE' : '#FAFBFC',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '&:hover': {
            borderColor: '#3B4797',
            bgcolor: hasAttachments ? '#ECEDF9' : 'rgba(59, 71, 151, 0.03)',
          },
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1.5,
            bgcolor: hasAttachments ? '#3B479715' : '#F0F2F5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            transition: 'all 0.2s',
          }}
        >
          {hasAttachments ? (
            <AttachFileOutlinedIcon sx={{ fontSize: 18, color: '#3B4797' }} />
          ) : (
            <AddOutlinedIcon sx={{ fontSize: 18, color: '#98A2AE' }} />
          )}
        </Box>

        <Stack flex={1} spacing={0}>
          <Typography variant='body2' fontWeight={600} sx={{ color: hasAttachments ? '#3B4797' : '#344054', fontSize: 13 }}>
            {hasAttachments ? 'View Attachments' : 'Add Attachment'}
          </Typography>
          {hasAttachments ? (
            <Typography variant='caption' sx={{ color: '#667085', fontSize: 11 }}>
              Click to manage files
            </Typography>
          ) : (
            <Typography variant='caption' sx={{ color: '#98A2AE', fontSize: 11 }}>
              Images, documents, videos, or links
            </Typography>
          )}
        </Stack>

        {hasAttachments && (
          <Chip
            label={totalAttachment}
            size='small'
            sx={{
              height: 22,
              minWidth: 22,
              fontSize: 12,
              fontWeight: 700,
              bgcolor: '#3B4797',
              color: '#fff',
              flexShrink: 0,
            }}
          />
        )}
      </Box>
    </Stack>
  );
}
